import(/* webpackMode: "eager" */ "/codebuild/output/src1195235403/src/ui-directo/apps/onboarding/src/app/error.tsx");
